<template>
  <div id="page">
    <!-- 精簡版分頁組件 -->
    <div class="page-info">共 {{ totalLists }} 筆</div>
    <el-pagination
      :layout="paginationLayout"
      :page-size="pageSize"
      :total="totalLists"
      :current-page="internalCurrentPage"
      :pager-count="5"
      @current-change="currentChange"
    >
    </el-pagination>
    <!-- pager-count 必須是奇數且在 5-21 之間，設置為 5 (最小值) -->
  </div>
</template>

<script>
import { notify } from '../utils/notify';
export default {
  props: {
    totalLists:{
      type: Number,
      required: true,
    },
    pageSize: {
      type: Number,
      required: true,
    },
    propsCurrentPage: {
      type: Number,
      required: true,
    },
    prevNextOnly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      internalCurrentPage: this.propsCurrentPage,
      paginationKey: 0
    };
  },
  watch: {
    propsCurrentPage(newVal) {
      this.internalCurrentPage = newVal;
    }
  },  
  computed: {
    currentPage(){
      return this.propsCurrentPage
    },
    paginationLayout() {
      return this.prevNextOnly ? 'prev, next' : 'prev, pager, next';
    },
  },
  methods: {
    currentChange(val) {
      // 檢查頁碼是否超過1000
      if (val > 1000) {
        notify({
          title: "提示",
          message: "頁數不可超過 1000 頁",
          type: "warning"
        });
        // 重置回原來的頁碼並強制重新渲染
        this.$nextTick(() => {
          this.internalCurrentPage = this.propsCurrentPage;
          this.paginationKey++; // 強制重新渲染以清空 jumper 輸入框
        });
        return;
      }
      this.internalCurrentPage = val;      
      this.$emit("currentChange", val);
    },
  },
};
</script>

<style lang="scss" scoped>
#page {
  width: 100%;
  margin-top: 0.75rem; /* 12px/16px = 0.75rem */
  display: flex;
  align-items: center;
  justify-content: flex-end;
  
  .page-info {
    margin-right: 1rem;
    color: #606266;
    font-size: 0.875rem; /* 14px/16px = 0.875rem */
  }
}
</style>